import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import "htmx.org"
import "../controllers"
import "chartkick"
import "../htmx_config"
import "./application.scss"

import ReactRailsUJS from "react_ujs"
const componentRequireContext = require.context("../components", true)
ReactRailsUJS.useContext(componentRequireContext)

// Debug: log UJS and components loaded
console.debug("[ReactRailsUJS] Initialized", {
  keys: componentRequireContext.keys(),
  totalComponents: componentRequireContext.keys().length
})

// Track mounted components to prevent duplicate mounting
const mountedComponents = new Set()

function mountReactComponents() {
  try {
    const nodes = document.querySelectorAll('[data-react-class]')
    console.debug(`[ReactRailsUJS] mount trigger. nodes=${nodes.length}`)
    
    // Only mount components that haven't been mounted yet
    const unmountedNodes = Array.from(nodes).filter(node => {
      const componentName = node.getAttribute('data-react-class')
      const isMounted = mountedComponents.has(componentName)
      if (!isMounted) {
        mountedComponents.add(componentName)
      }
      return !isMounted
    })
    
    if (unmountedNodes.length > 0) {
      console.debug(`[ReactRailsUJS] mounting ${unmountedNodes.length} new components`)
      ReactRailsUJS.mountComponents()
    } else {
      console.debug('[ReactRailsUJS] no new components to mount')
    }
  } catch (e) {
    console.error('[ReactRailsUJS] mount error', e)
  }
}

function unmountReactComponents() {
  try {
    console.debug('[ReactRailsUJS] unmounting components')
    ReactRailsUJS.unmountComponents()
    mountedComponents.clear()
  } catch (e) {
    console.error('[ReactRailsUJS] unmount error', e)
  }
}

document.addEventListener('DOMContentLoaded', mountReactComponents)
document.addEventListener('turbo:load', () => {
  unmountReactComponents()
  mountReactComponents()
})

document.addEventListener('turbo:render', () => {
  console.debug('[ReactRailsUJS] turbo:render')
  // Don't mount on turbo:render to avoid duplicates
})

// Stimulusアプリケーションの初期化
window.Stimulus = Application.start()

// htmxをturbo:loadで読み込む
document.addEventListener('turbo:load', function() {
  if (typeof htmx !== 'undefined') {
    htmx.process(document.body);
  }
});
